import { jvmCriterion } from '../../../../searchCriteria';

import { QuickSearchFilter } from '@cast/shared-search-ui';

const jvmOptions = [{ title: 'JVM', value: 'true' }];

export const JvmQuickSearch = () => {
  return <QuickSearchFilter options={jvmOptions} criterion={jvmCriterion} />;
};
